var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",attrs:{"transform":`rotate(${_vm.rotate})`,"width":_vm.width,"height":_vm.height},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('use',{attrs:{"xlink:href":`${_vm.staticPublicPrefix}assets/images/sprite.svg#${_vm.icon}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }